import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import { LOCALE_DEFAULT } from '../../constants/consts';
import { resources } from '../../locales';
const i18n = i18next.createInstance();
const init = (lang) => {
    i18n.use(initReactI18next).init({
        lng: lang || LOCALE_DEFAULT,
        fallbackLng: LOCALE_DEFAULT,
        resources,
        interpolation: {
            escapeValue: false,
        },
    });
};
export { i18n, init };
//# sourceMappingURL=i18n.js.map